import { useCallback, useState } from 'react';
import { Box, ButtonBase, ClickAwayListener, makeStyles, Popper } from '@material-ui/core';
import { AddIcon } from '../Icon';

const useStyles = makeStyles(() => ({
  remarkColorPopup: {
    zIndex: '9999',
  },
  item: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
    padding: '6px 16px',
    justifyContent: 'flex-start',
    textAlign: 'left',
    '&:hover': {
      backgroundColor: '#f1f6ff',
      color: '#538fff',
    },
  },
  addRemarkBtn: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#538fff',
    fontWeight: 'bold',
  },
  addIcon: {
    marginRight: '0.5rem',
  },
}));

const AddRemarks = ({ handleSelect, list }) => {
  const classes = useStyles();
  const [remarkPopupAnchorEl, setRemarkPopupAnchorEl] = useState(null);

  // remark popup 开关
  const handleOpenRemarkPopup = useCallback(
    (event) => {
      setRemarkPopupAnchorEl(remarkPopupAnchorEl ? null : event.currentTarget);
    },
    [remarkPopupAnchorEl]
  );

  // 关闭remark popup
  const handleCloseRemarkPopup = useCallback(() => {
    setRemarkPopupAnchorEl(null);
  }, []);

  const handleAddRemark = (content, colour) => () => {
    handleSelect(content, colour);
    setRemarkPopupAnchorEl(null);
  };

  return (
    <>
      <ButtonBase className={classes.addRemarkBtn} onClick={handleOpenRemarkPopup}>
        <AddIcon className={classes.addIcon} />
        Add Remarks
      </ButtonBase>
      {Boolean(remarkPopupAnchorEl) && (
        <ClickAwayListener onClickAway={handleCloseRemarkPopup}>
          <Popper
            className={classes.remarkColorPopup}
            open={Boolean(remarkPopupAnchorEl)}
            anchorEl={remarkPopupAnchorEl}
            placement="bottom"
            transition
          >
            <Box
              display="flex"
              flexDirection="column"
              minWidth="13rem"
              maxWidth="25rem"
              border="solid 1px #e4e7eb"
              bgcolor="#fff"
              boxShadow="0 1px 6px 0 rgba(0, 0, 0, 0.12)"
              borderRadius="10px"
              padding="0.5rem 0"
              maxHeight="22rem"
              overflow="auto"
            >
              {list.length > 0 ? (
                list.map((item) => (
                  <ButtonBase
                    className={classes.item}
                    key={item.remarkId}
                    onClick={handleAddRemark(item.content, item.colour)}
                  >
                    {item.content}
                  </ButtonBase>
                ))
              ) : (
                <ButtonBase className={classes.item} disabled>
                  No Option
                </ButtonBase>
              )}
            </Box>
          </Popper>
        </ClickAwayListener>
      )}
    </>
  );
};

export default AddRemarks;
